/**
 * Slice C.1 · ExpensePreview.
 * Reads canonical `presentation.data` (expense_preview shape).
 * Never invents fields.
 */
export function ExpensePreview({ presentation }) {
  const d = presentation.data || {};
  const amount   = Number.isFinite(d.amount_pounds) ? d.amount_pounds : null;
  const category = typeof d.category === "string" ? d.category : null;
  const note     = typeof d.note     === "string" ? d.note     : null;
  const dateStr  = typeof d.date     === "string" ? d.date     : null;

  return (
    <div data-testid="ui-response-expense-preview" className="space-y-2">
      <p className="text-[14px] leading-relaxed text-zinc-100">
        {presentation.narration}
      </p>
      <dl className="text-[13px] grid grid-cols-2 gap-x-3 gap-y-1 text-zinc-300">
        {amount !== null && (<><dt className="text-zinc-500">Amount</dt><dd data-testid="ui-expense-amount">£{amount.toFixed(2)}</dd></>)}
        {category && (<><dt className="text-zinc-500">Category</dt><dd data-testid="ui-expense-category">{category}</dd></>)}
        {dateStr && (<><dt className="text-zinc-500">Date</dt><dd data-testid="ui-expense-date">{dateStr}</dd></>)}
        {note && (<><dt className="text-zinc-500">Note</dt><dd className="col-span-2 text-zinc-200" data-testid="ui-expense-note">{note}</dd></>)}
      </dl>
    </div>
  );
}

export default ExpensePreview;
